<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      translationService.getFprTemplatesText()
    }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button (click)="goToCreate()">
    {{ translationService.getCreateTemplateText() }}
  </button>
  <app-fpr-template-list></app-fpr-template-list>
</mat-expansion-panel>
